// testing midleware 
// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '477da7dc-e9e4-4bad-bfdc-a13bc0b15759',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '64b76a77-730e-409f-982b-b180172487ec',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Button_Background',
      parent: '477da7dc-e9e4-4bad-bfdc-a13bc0b15759',
      stateByName: {
        'move-disabled': {
          texture: 'Booster_Button_Background'
        },
        'hammer-disabled': {
          texture: 'Booster_Button_Background'
        }
      }
    },
    {
      id: '07379aae-e9a9-4f25-9cce-995cb61c0b5e',
      type: 'Container',
      name: 'buttonGroup',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '477da7dc-e9e4-4bad-bfdc-a13bc0b15759',
      interactiveChildren: false
    },
    {
      id: 'f93ac87d-577a-46e3-ae7f-eb3770adcfcf',
      type: 'Sprite',
      name: 'indicator',
      className: '',
      x: 49,
      y: -50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Inventory_Background',
      parent: '477da7dc-e9e4-4bad-bfdc-a13bc0b15759',
      stateByName: {
        'no-indicator': {
          visible: false
        }
      }
    },
    {
      id: '34e1afbf-07f5-4eeb-a2c3-235989a8e9d3',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.396601,
        y: 0.401146
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Button',
      parent: '07379aae-e9a9-4f25-9cce-995cb61c0b5e',
      stateByName: {
        'move-disabled': {
          texture: 'Booster_Button_Grey'
        },
        'hammer-disabled': {
          texture: 'Booster_Button_Grey'
        },
        'redraw-disabled': {
          texture: 'Booster_Button_Grey'
        },
        'undo-disabled': {
          texture: 'Booster_Button_Grey'
        }
      }
    },
    {
      id: '771eb344-9f81-477d-bc91-42028d4e0184',
      type: 'Sprite',
      name: 'attractOverlay',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'boosterButtonAttract',
      parent: '07379aae-e9a9-4f25-9cce-995cb61c0b5e',
      stateByName: {
        'no-indicator': {
          visible: false
        }
      }
    },
    {
      id: '31e9737d-1227-4e2f-8328-9574e9843bf6',
      type: 'Sprite',
      name: 'iconShadow',
      className: '',
      x: 5,
      y: 4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.73913,
        y: 0.758334
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16746499,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Swap_Booster_Shadow',
      parent: '07379aae-e9a9-4f25-9cce-995cb61c0b5e',
      stateByName: {
        'move-disabled': {
          texture: 'Move_Booster_Shadow',
          x: 5,
          y: 4,
          tint: '0x808080'
        },
        'hammer-disabled': {
          texture: 'Hammer_Booster_Shadow',
          x: 9,
          y: 5,
          tint: '0x808080'
        },
        'hammer-enabled': {
          x: 9,
          y: 5,
          texture: 'Hammer_Booster_Shadow'
        },
        'move-enabled': {
          x: 5,
          y: 4,
          texture: 'Move_Booster_Shadow'
        },
        'redraw-disabled': {
          texture: 'Swap_Booster_Shadow',
          x: 5,
          y: 4,
          tint: '0x808080'
        },
        'redraw-enabled': {
          texture: 'Swap_Booster_Shadow',
          x: 5,
          y: 4
        },
        'undo-enabled': {
          texture: 'Undo_Booster_Shadow'
        },
        'undo-disabled': {
          texture: 'Undo_Booster_Shadow',
          tint: '0x808080'
        }
      }
    },
    {
      id: '7d935ce9-9eca-48d4-90ba-7ab114f159f1',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 0,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.369565,
        y: 0.379167
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Swap_Booster',
      parent: '07379aae-e9a9-4f25-9cce-995cb61c0b5e',
      stateByName: {
        'move-disabled': {
          texture: 'Move_Booster_Grey',
          x: 0
        },
        'hammer-disabled': {
          texture: 'Hammer_Booster_Grey',
          x: 6,
          y: -1
        },
        'hammer-enabled': {
          x: 6,
          y: -1,
          texture: 'Hammer_Booster'
        },
        'move-enabled': {
          x: 0,
          y: -1,
          texture: 'Move_Booster'
        },
        'redraw-disabled': {
          texture: 'Swap_Booster_Grey'
        },
        'redraw-enabled': {
          texture: 'Swap_Booster'
        },
        'undo-enabled': {
          texture: 'Undo_Booster'
        },
        'undo-disabled': {
          texture: 'Undo_Booster_Grey'
        }
      }
    },
    {
      id: 'ed77c19b-c118-47ce-886e-4affe39ade17',
      type: 'Text',
      name: 'indicatorText',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 27,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f93ac87d-577a-46e3-ae7f-eb3770adcfcf',
      stateByName: {
        'move-enabled': {
          localize: false
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'move-enabled',
    'move-disabled',
    'hammer-enabled',
    'hammer-disabled',
    'redraw-enabled',
    'redraw-disabled',
    'undo-enabled',
    'undo-disabled',
    'no-indicator'
  ],
  handleResize: false
} as const;

export class BoosterButtonLayout {
  static raw = raw;
  root!: Container;
  background!: Sprite;
  buttonGroup!: Container;
  indicator!: Sprite;
  attractOverlay!: Sprite;
  iconShadow!: Sprite;
  icon!: Sprite;
  indicatorText!: Text;
  StateName!: 'move-enabled' | 'move-disabled' | 'hammer-enabled' | 'hammer-disabled' | 'redraw-enabled' | 'redraw-disabled' | 'undo-enabled' | 'undo-disabled' | 'no-indicator';

  constructor() {
    populate(this, raw);
  }
}
